import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "excursion_wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredExcursions, (excursion) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.viewComponent), {
        excursion: excursion,
        key: excursion.id
      }, null, 8, ["excursion"]))
    }), 128)),
    (_ctx.paginate < _ctx.excursions.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "items_loader",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.paginate += 20))
        }, " Загрузить еще "))
      : _createCommentVNode("", true)
  ]))
}